const PDFOutlinedIcons = () => {
    return (
        <div>
            <svg
                viewBox="0 0 20 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2ZM2 14H18V2H2V14Z"
                    fill="#EA4336"
                />
                <path
                    d="M14 10.5H13V5.5H15V6.5H14V7.5H15V8.5H14V10.5Z"
                    fill="#EA4336"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5 10.5H6V8.5H7C7.28333 8.5 7.52083 8.40417 7.7125 8.2125C7.90417 8.02083 8 7.78333 8 7.5V6.5C8 6.21667 7.90417 5.97917 7.7125 5.7875C7.52083 5.59583 7.28333 5.5 7 5.5H5V10.5ZM6 6.5V7.5H7V6.5H6Z"
                    fill="#EA4336"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 5.5V10.5H11C11.2833 10.5 11.5208 10.4042 11.7125 10.2125C11.9042 10.0208 12 9.78333 12 9.5V6.5C12 6.21667 11.9042 5.97917 11.7125 5.7875C11.5208 5.59583 11.2833 5.5 11 5.5H9ZM10 6.5V9.5H11V6.5H10Z"
                    fill="#EA4336"
                />
            </svg>
        </div>
    )
}

export default PDFOutlinedIcons
